import React, { Component } from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import InputMask from 'react-input-mask';
import { ToastContainer, toast } from 'react-toastify';
import { connect } from 'react-redux';
import * as actions from '../../actions/actions.jsx'
import s from '../../services/allservices.jsx'
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import Loader from '../loader/loader.jsx'
import Toggle from 'material-ui/Toggle';
const styles = {
    block: {
        maxWidth: 250,
    },
    radioButton: {
        marginBottom: 16,
    },
    blockmargin: {
        marginBottom: 20
    },
    radioIcon: {
        fill: "#333"
    },
    toggle: {
        marginBottom: 16,
    },
    thumbSwitched: {
        backgroundColor: 'red',
    },
    trackSwitched: {
        backgroundColor: '#ff9d9d',
    },
};

const mapStateToProps = state =>
    ({
        publicKey: state.publicKey.publicKey,
        keyRecieved: state.publicKey.keyRecieved,
        cardState: state.getCardReducer.cardState
    })
const mapDispatchToProps = dispatch =>
    ({
        fetchCard(state) {
            dispatch(
                actions.getCardAction(state)
            )
        }
    })

const JSEncrypt = window.JSEncrypt
class SuspendCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cardDetailsId: "",
            selectedCard: [],
            cardStatus: "",
            loader: true,
            Toggled: false
        }
    }
    componentDidMount() {
        const { publicKey } = this.props
        let _this = this

        setTimeout(function () {
            if (publicKey.status === 200) {
                const public_Key = publicKey.body.publickey;
                let encrypt = new JSEncrypt();
                encrypt.setPublicKey(public_Key);


                const state = {
                    applicationId: "gmcabs",
                    accountId: encrypt.encrypt(localStorage.getItem("accountId"))
                }
                _this.props.fetchCard(state)
            }
        }, 500);


    }


    componentWillReceiveProps(nextProps) {

        try {
            if (nextProps.cardState && nextProps.cardState.length !== 0) {
                this.setState({
                    cardDetailsId: nextProps.cardState.body[0].cardDetailsId,
                    selectedCard: nextProps.cardState.body[0]
                }, () => {
                    if (this.state.selectedCard && this.state.selectedCard.cardStatus === "Open") {
                        this.setState({
                            Toggled: false,
                            cardStatus: 'I'
                        })
                    } else {
                        this.setState({
                            Toggled: true,
                            cardStatus: 'B'
                        })
                    }
                })
            }

        } catch (e) {

        }

    }
    onChange = (e, value) => this.setState({ [e.target.name]: e.target.value })

    handleChange2 = (e, value) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    handleBlock() {
        this.setState({
            loader: true
        })
        const { publicKey } = this.props
        if (publicKey.status === 200) {
            const public_Key = publicKey.body.publickey;
            let encrypt = new JSEncrypt();
            encrypt.setPublicKey(public_Key);

            let state = {
                applicationId: "gmcabs",
                cardDetailsId: encrypt.encrypt(this.state.cardDetailsId),
                cardStatus: encrypt.encrypt(this.state.cardStatus)
            }

            fetch(s.block_card, {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': "Token " + localStorage.getItem('token')
                }),
                body: JSON.stringify(state)
            })
                .then(response => {
                    if (response.status === 200 || response.status === 201) {
                        toast.success(response.headers.get('message'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        });
                        this.setState({
                            loader: false
                        })
                    }
                   else if (response.status === 204) {
                        toast.success(response.headers.get('message'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        });
                        this.setState({
                            loader: false
                        })
                        setTimeout(function () { window.location.reload(true); }, 3000);
                    }
                 
                    else {
                        this.setState({
                            loader: true
                        })
                        toast.error(response.headers.get('message'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        });
                    }
                })

        }

    }


    handleSelect1 = (event, index, value) => {
        const { cardState } = this.props

        this.setState({ cardDetailsId: value }, () => {
            for (let i = 0; i < cardState.body.length; i++) {
                if (this.state.cardDetailsId === cardState.body[i].cardDetailsId) {
                    this.setState({
                        selectedCard: cardState.body[i]
                    }, () => {
                        if (this.state.selectedCard && this.state.selectedCard.cardStatus === "Open") {
                            this.setState({
                                Toggled: false,
                                cardStatus: 'I'
                            })
                        } else {
                            this.setState({
                                Toggled: true,
                                cardStatus: 'B'
                            })
                        }
                    })
                }
            }
        });

    }
    handleToggle() {
        this.setState({ Toggled: !this.state.Toggled });
        console.log(this.state.Toggled)
        {
            this.state.Toggled === true ?
            this.setState({
                cardStatus: "B",
            })
            :
            this.setState({
                cardStatus: "I",
            })
        }
    }


    render() {
        const { cardState } = this.props
        const { cardDetailsId, selectedCard } = this.state
        return (
            <div style={{ padding: "0px 30px" }}>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnVisibilityChange
                    draggable
                    pauseOnHover
                />
                <div className="top-header text-left">
                    <p>
                        Choose the card you want to block from the drop down list and click ‘OK’.
                        You may be asked some security questions prior to the reactivation of your card.
                    </p>
                </div>
                {cardState.status === 200 && cardState.body.length !== 0 && selectedCard.length !== 0 ?
                    <div className="col-sm-12">
                        <div className="card-account">
                            <div className="tile box-shadow-style">
                                <div className="row">
                                    <div className="col-md-12" style={{ padding: "0px 15px" }}>
                                        <div className="summary-header">
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <p>Card Account</p>
                                                </div>
                                                <div className="offset-md-2 col-md-6 text-right">
                                                    <div className="row">
                                                        <div className="col-sm-2 input-icon" >
                                                            {/* <img src={creditcardlogo} alt="" /> */}
                                                        </div>
                                                        <div className="col-sm-10" >
                                                            <SelectField
                                                                floatingLabelText=""
                                                                onChange={this.handleSelect1}
                                                                className="input-width"
                                                                name="Selected Card"
                                                                style={{ marginTop: -12 }}
                                                                value={cardDetailsId}>
                                                                {cardState.body.map((value, i) =>
                                                                    <MenuItem value={cardState.body[i].cardDetailsId} primaryText={cardState.body[i].cardNumber} key={i} />
                                                                )}
                                                            </SelectField>
                                                        </div>
                                                    </div>

                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-sm-12">
                                        <div className="row">
                                            <div className="col-md-5  tilepadding">
                                                <label className="tilecontent">Card Number </label>
                                            </div>
                                            <div className="col-md-6 text-left tilepadding">
                                                <span className="tileheadername">{selectedCard.cardNumber} </span><br />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-5  tilepadding">
                                                <label className="tilecontent">Name on Card </label>
                                            </div>
                                            <div className="col-md-6 text-left tilepadding">
                                                <span className="tileheadername">{selectedCard.firstName + " " + selectedCard.lastName}  </span><br />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-5  tilepadding">
                                                <label className="tilecontent">Last Transaction </label>
                                            </div>
                                            <div className="col-md-6 text-left tilepadding">
                                                <span className="tileheadername">{selectedCard.lastCreditPosted}   </span><br />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-sm-12">
                                        <div className="row">
                                            <div className="col-md-4  tilepadding">
                                                <label className="tilecontent">Available Balance </label>
                                            </div>
                                            <div className="col-md-8 text-left tilepadding">
                                                <span className="tileheadername">{selectedCard.ledgerBalance}</span><br />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4  tilepadding">
                                                <label className="tilecontent">Card Status </label>
                                            </div>
                                            <div className="col-md-8 text-left tilepadding">
                                                <span className="tileheadername">{selectedCard.cardStatus} </span><br />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    : <Loader />
                }
                <div className="col-sm-12">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="block-card-header" style={styles.blockmargin}>
                                <h6>Block Card Options</h6>
                            </div>
                        </div>
                        <div className="offset-sm-2 col-sm-4">
                            <div className="block-card-body">
                                {/* <RadioButtonGroup name="cardStatus" defaultSelected="I" onChange={this.handleChange2.bind(this)}>
                                    <RadioButton
                                        value="I"
                                        name="block"
                                        label="Block My Card (Temporarily Inactive)"
                                        style={styles.radioButton}
                                        iconStyle={styles.radioIcon}

                                    />
                                </RadioButtonGroup> */}
                                <Toggle
                                    label="Block/ Unblock My Card "
                                    labelPosition="right"
                                    style={styles.toggle}
                                    thumbSwitchedStyle={styles.thumbSwitched}
                                    trackSwitchedStyle={styles.trackSwitched}
                                    defaultToggled={this.state.Toggled}
                                    onToggle={this.handleToggle.bind(this)}
                                />
                                {/* <RadioButton
                                        value="mb"
                                        name="replace"
                                        label=" My card is damaged. Send me a replacement.   [$0.00]"
                                        style={styles.radioButton}
                                        iconStyle={styles.radioIcon}
                                       
                                    />
                                    <RadioButton
                                        value="mc"
                                        name="newcard"
                                        label="My card is lost or stolen. Issue me a new card.   [$0.00]"
                                        style={styles.radioButton}
                                        iconStyle={styles.radioIcon}
                                       
                                    /> */}

                                <RaisedButton
                                    label="Ok"
                                    className=""
                                    // style={styles.button}
                                    backgroundColor="#333"
                                    labelColor="#fff"
                                    data-toggle="modal"
                                    data-target="#blockModal"
                                //
                                // icon={<i className="fa fa-search" aria-hidden="true" style={{ color: "#fff" }}></i>}
                                />
                                <div className="modal fade" id="blockModal" role="dialog">
                                    <div className="modal-dialog ">
                                        <div className="modal-content " style={{ marginTop: "150px", background: "rgb(214, 70, 84)" }}>
                                            <div className="modal-header" style={{ padding: "3px", borderBottom: "none", height: "45px" }}>
                                                <div className="col-sm-12" style={{ marginTop: "7px" }}>
                                                    <div className="row">
                                                        <div className="col-sm-6" style={{ fontSize: "19px", fontWeight: "600", color: "rgb(255, 255, 255)" }}>
                                                            <span>{selectedCard.cardStatus === 'Open' ? 'Block Card' : 'Unblock Card'}</span>
                                                        </div>
                                                        <div className="offset-4 col-sm-2" style={{ float: "right", color: "rgb(119, 119, 119)" }}>
                                                            <button type="button" className="close" data-dismiss="modal">&times;</button>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="modal-body text-center" style={{ backgroundColor: "#fff" }}>
                                                <div className="col-sm-12" >
                                                    <i className="fa fa-question fa-4x mb-3 animated rotateIn" style={{ color: "rgb(214, 70, 84)" }}></i>
                                                </div>
                                                <div className="col-sm-12" style={{ fontSize: "20px" }}>
                                                    <span>Are you sure, you want to {selectedCard.cardStatus === 'Open' ? 'block' : 'unblock'} the card? </span>
                                                </div>
                                                <div className="col-sm-12" >
                                                    <button type="button" className="btn btn-default" style={{ marginRight: "10px", backgroundColor: "#fff", fontSize: "13px", fontWeight: "bold", marginTop: "8px", border: "2px solid rgb(119, 119, 119)" }} data-dismiss="modal">Cancel</button>
                                                    <button type="button" className="btn btn-outline-danger waves-effect" style={{ fontSize: "13px", fontWeight: "bold", marginTop: "8px", border: "2px solid rgb(214, 70, 84)" }} onClick={this.handleBlock.bind(this)} data-dismiss="modal">Ok</button>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        )
    }
}
SuspendCard.defaultProps = {
    cardState: {
        status: 600
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SuspendCard);


// WEBPACK FOOTER //
// ./src/components/additionalservices/suspendcard.jsx